const generateQueryString = function (data) {
  //Do something with the input
  for (const item in data) {
    if (data[item] === null || data[item] === undefined || data[item] === "") {
      delete data[item];
    }
  }
  return Object.keys(data)
    .map((key) => key + "=" + data[key])
    .join("&");
};
exports.generateQueryString = generateQueryString;
